import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { IMAGES, STATS_CLIENTS } from "../mock";
import SearchWidget from "./SearchWidget";

const Hero = ({ onSearch, destinations, hotels }) => {
  const { t } = useLanguage();

  return (
    <section id="top" className="relative">
      <div className="absolute inset-0">
        <img
          src={IMAGES.heroA}
          alt="Cancún turquoise coastline"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d3b43]/80 via-[#0d3b43]/55 to-[#0d3b43]/85" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-28 sm:pt-20">
        <div className="text-center max-w-3xl mx-auto rc-fade-up">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur border border-white/25 rounded-full px-4 py-1.5 mb-5">
            <span className="text-white text-sm font-semibold tracking-wide">
              {STATS_CLIENTS.toLocaleString("en-US")} {t("clientsServed")}
            </span>
          </div>
          <h1 className="font-display font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {t("heroTitle")}
            <span className="block text-cyan-300 mt-1">{t("heroBrand")}</span>
          </h1>
          <p className="text-white/85 mt-4 text-base sm:text-lg">{t("heroSub")}</p>
        </div>

        <div className="mt-10 rc-fade-up" style={{ animationDelay: "0.1s" }}>
          <SearchWidget onSearch={onSearch} destinations={destinations} hotels={hotels} />
        </div>
      </div>
    </section>
  );
};

export default Hero;
